import { unininitializedState } from '../store'

import {
  BEGIN_INITIALIZATION,
  INITIALIZE_VIEW_TYPE,
  CLEAR_ALL,
  SET_TITLE_VIA_FIREBASE,
  SET_DESCRIPTION_VIA_FIREBASE
} from '../actions/actionTypes'

function listInfo (state = {}, action) {
  switch (action.type) {
    case BEGIN_INITIALIZATION:
      return {
        ...state,
        listId: action.listId
      }

    case INITIALIZE_VIEW_TYPE:
      return {
        ...state,
        viewType: action.viewType
      }

    case CLEAR_ALL:
      return unininitializedState.listInfo

    case SET_TITLE_VIA_FIREBASE:
      return {
        ...state,
        title: action.title
      }

    case SET_DESCRIPTION_VIA_FIREBASE:
      return {
        ...state,
        description: action.description
      }

    default:
      return state
  }
}

export default listInfo



// WEBPACK FOOTER //
// ./src/reducers/listInfo.js